// Contrail V3.9.0 — shown on every page while the signed-in Skyward admin has a Support view open
// (they can then see that client company's live positions, history and reports). Ends at the set time or on "End now".
import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";
import { adminApi } from "../lib/admin";

type Active = { id: number; org_id: string; org_name: string; reason: string; expires_at: string };

export function useSupportSession() {
  const [s, setS] = useState<Active | null>(null);
  useEffect(() => {
    let live = true;
    const load = () => supabase.rpc("my_support_session").then(({ data }) => { if (live) setS((data as Active | null) ?? null); });
    load();
    const t = setInterval(load, 60_000);
    return () => { live = false; clearInterval(t); };
  }, []);
  return s;
}

const left = (iso: string) => {
  const m = Math.max(0, Math.round((Date.parse(iso) - Date.now()) / 60_000));
  return m >= 60 ? `${Math.floor(m / 60)} h ${m % 60} min left` : `${m} min left`;
};

export default function SupportBanner() {
  const s = useSupportSession();
  const [, tick] = useState(0);
  const [busy, setBusy] = useState(false);
  useEffect(() => { const t = setInterval(() => tick((n) => n + 1), 30_000); return () => clearInterval(t); }, []);
  if (!s) return null;
  if (Date.parse(s.expires_at) <= Date.now()) { setTimeout(() => window.location.reload(), 0); return null; }
  async function end() {
    setBusy(true);
    try { await adminApi("POST", "support/end", {}); } finally { window.location.reload(); }
  }
  return (
    <div className="support-banner" role="status" title={`Reason: ${s.reason}`}>
      <b>Support view</b><span>{s.org_name}</span><span className="sb-left">{left(s.expires_at)}</span>
      <button type="button" onClick={end} disabled={busy}>{busy ? "Ending…" : "End now"}</button>
    </div>
  );
}
